var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H35.9424V26H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8326 0H3.1081C1.39882 0 0.0117188 1.38667 0.0117188 3.09508V22.9047C0.0117188 24.6133 1.39882 26 3.1081 26H32.8326C34.5419 26 35.929 24.6133 35.929 22.9047V3.09508C35.929 1.38667 34.5419 0 32.8326 0ZM24.3302 11.7743L34.4799 2.24705C34.6099 2.50705 34.6905 2.79175 34.6905 3.09508V22.9047C34.6905 23.14 34.6409 23.3627 34.5605 23.5733L24.3302 11.7743ZM32.8326 1.23803C33.0989 1.23803 33.3528 1.29372 33.5758 1.39902L17.9704 16.0457L2.36494 1.39902C2.58789 1.29372 2.84182 1.23803 3.1081 1.23803H32.8326ZM1.38019 23.5733C1.2998 23.3627 1.25019 23.14 1.25019 22.9047V3.09508C1.25019 2.79175 1.33079 2.50705 1.46079 2.25333L11.6105 11.7804L1.38019 23.5733ZM3.1081 24.7617C2.77357 24.7617 2.47024 24.669 2.19767 24.5143L12.5147 12.6223L17.5431 17.3457C17.6607 17.4571 17.8154 17.5127 17.9641 17.5127C18.1127 17.5127 18.2676 17.4571 18.3853 17.3457L23.4137 12.6223L33.743 24.5143C33.4705 24.669 33.1671 24.7617 32.8326 24.7617H3.1081Z",
    fill: "#00477A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6c9100aa51f3d0a40f21ca8cf16ea337.svg";
export { ForwardRef as ReactComponent };